export default __webpack_public_path__ + "static/media/congratulation.d2aee30b.svg";